import React, { useState } from 'react';
import '../../entrydoor.css';

const OperatingSideLite = ({ value, onChange, label = 'Operating Side Lite' }) => {
    const [selectedOperatingSideLite, setSelectedOperatingSideLite] = useState(value || "");

    const handleOperatingSideLiteChange = (e) => {
        setSelectedOperatingSideLite(e.target.value);
        onChange(e.target.value);
        //alert(e.target.value)
        
        const element = document.getElementById("OperatingSideLiteWarning");
            if (element){
                if (e.target.value === 'Yes'){
                    element.style.display = "block";
                }
                else{
                    element.style.display = "None";
                    //alert(e.target.value)
                }
            }
    
    };

    return (
        <div className="a-container">
            <label  style={{ display: 'block' }} htmlFor="OperatingSideLite">{label}</label>
            <select style={{ display: 'block' }} 
                id="OperatingSideLite"
                value={selectedOperatingSideLite}
                onChange={handleOperatingSideLiteChange}
            >
                <option value="" disabled hidden>Select an option</option>
                <option value="Yes">{selectedOperatingSideLite === "Yes" ? 'Yes ✔' : 'Yes'}</option>
                <option value="No">{selectedOperatingSideLite === "No" ? 'No ✔' : 'No'}</option>
            </select>
            <div className = "jamb-warning" id="OperatingSideLiteWarning"  style={{ display: 'none' }}  >
            
            An Operating Side Lite requires an astragal. Please re-check your Frame Width as it may have changed due to this option.
            
            </div>
        </div>
    );
};

export default OperatingSideLite;
